'use client'

import React from 'react'
import NavigationAuthed, { NavigationProps } from './NavigationAuthed'
import NavigationPublic from './NavigationPublic'
import useAuth from '@crystal-eyes/hooks/useAuth'

export default function Navigation(props: NavigationProps) {
  const { authed, loading } = useAuth()
  if (loading) return null

  return authed ? <NavigationAuthed {...props} /> : <NavigationPublic />
}
